
import React, {useEffect} from "react";


function scientificLlaboratories() {

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        window.location.href = "https://lab.tdtu.uz";
    }, []);

  return (
    <>
     456
    </>
  );
}

export default scientificLlaboratories;
